// Links inside v-html cannot use <RouterLink> so we add a handler for the link
// which calls rounter.push() when the link is clicked
// See: https://github.com/nuxt-community/markdownit-module/issues/16

import { App } from 'vue';

function navigate(event: MouseEvent) {
    if (event.target instanceof Element) {
        const href = event.target.getAttribute('href');
        const target = event.target.getAttribute('target');
        if (href && href[0] === '/' && target !== '_blank') {
            event.preventDefault();
            const router = useRouter();
            router.push(href);
        }
    }
}

function addListeners(el: Element) {
    const links = el.getElementsByTagName('a');
    for (let i = 0; i < links.length; i++) {
        links[i].addEventListener('click', navigate, false);
    }
}

function removeListeners(el: Element) {
    const links = el.getElementsByTagName('a');
    for (let i = 0; i < links.length; i++) {
        links[i].removeEventListener('click', navigate, false);
    }
}

const register = (app: App) => {
    app.directive('router-link', {
        mounted(el) {
            addListeners(el);
        },

        beforeUnmount(el) {
            removeListeners(el);
        },

        updated(el, binding) {
            removeListeners(el);
            return binding.instance?.$nextTick(() => {
                addListeners(el);
            });
        },
    });
};

export default register;
